<div class="select-assets">
    <!-- Left Panel: Preview -->
    <div class="select-assets__preview">
        @if (previewItem(); as item) {
            <div class="select-assets__preview-container">
                <div class="select-assets__preview-media">
                    @if (item.type === 'video') {
                        <video
                            [src]="item.src"
                            controls
                            [autoplay]="true"
                            [muted]="true"
                            (ended)="onVideoEnded()"
                            class="select-assets__preview-media-content"></video>
                    } @else {
                        <img
                            [src]="item.src"
                            [alt]="item.name"
                            class="select-assets__preview-media-content" />
                    }
                </div>

                <div class="select-assets__preview-info">
                    <div class="select-assets__preview-header">
                        <div class="flex items-center gap-3">
                            <h2 class="select-assets__preview-title">{{ item.name }}</h2>
                            <div class="select-assets__preview-item-duration">
                                <svg>
                                    <use xlink:href="assets/icons/icons-sprite.svg#clock"></use>
                                </svg>
                                <span class="text-xs text-description">{{
                                    item.duration | contentDuration
                                }}</span>
                            </div>
                        </div>
                        <span class="select-assets__preview-badge">{{ item.type }}</span>
                    </div>

                    <div class="select-assets__preview-details">
                        <h3 class="select-assets__preview-details-header">Content Details</h3>
                        <div class="select-assets__preview-details-list">
                            @for (detail of previewItemDetails(); track detail.label) {
                                <div class="select-assets__preview-details-item">
                                    <span class="select-assets__preview-label">{{
                                        detail.label
                                    }}</span>
                                    <span class="select-assets__preview-value">
                                        @switch (detail.type) {
                                            @case ('date') {
                                                {{ detail.value | date: 'MMM dd, yyyy' }}
                                            }
                                            @case ('duration') {
                                                {{ detail.value | contentDuration: 'long' }}
                                            }
                                            @default {
                                                {{ detail.value }}
                                            }
                                        }
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="select-assets__template-wrapper">
                <div class="select-assets__template-content">
                    <svg class="select-assets__template-icon">
                        <use xlink:href="assets/icons/icons-sprite.svg#play"></use>
                    </svg>
                    <h2 class="select-assets__template-title">
                        Welcome to your new playlist! Add content to get started.
                    </h2>
                    <p class="select-assets__template-description">
                        Select the content you want to add to this playlist
                    </p>
                </div>
            </div>
        }
    </div>

    <!-- Right Panel: Playlist Items -->
    <div class="select-assets__playlist">
        <div class="select-assets__playlist-header">
            <div class="select-assets__playlist-stats">
                {{ addedPlaylistContents().length }} items added
            </div>
            <div class="select-assets__playlist-actions">
                <ntv-button size="xl" variant="accent" (buttonClick)="onAddContent()">
                    <span class="select-assets__action-label">
                        <svg class="icon-svg--sm">
                            <use xlink:href="/assets/icons/icons-sprite.svg#plus"></use>
                        </svg>
                        Add Content
                    </span>
                </ntv-button>
                @if (showForTM()) {
                    <ntv-button size="xl" (buttonClick)="onUploadContent()">
                        <span class="select-assets__action-label">Upload Content</span>
                    </ntv-button>
                }
            </div>
        </div>

        <div class="select-assets__playlist-contents">
            @if (addedPlaylistContents().length > 0) {
                <div class="grid-contents grid-contents--5">
                    @for (item of addedPlaylistContents(); track item.id) {
                        <div
                            class="ntv-thumbnail-item--wrapper"
                            [class.ntv-thumbnail-item--wrapper--selected]="
                                previewItem()?.id === item.id
                            "
                            (click)="setPreviewItem(item)">
                            <ntv-thumbnail-item
                                [disableRightClick]="true"
                                [item]="item"
                                size="md"
                                [customWidth]="'100%'"
                                [customTextSize]="'12px'"
                                [eyeIconVisible]="false"
                                [showThumbnailInfoTag]="false"
                                [showActionButtons]="false" />

                            <button
                                class="ntv-thumbnail-item--wrapper__remove-btn"
                                (click)="onRemoveContent(item.id); $event.stopPropagation()">
                                <svg class="icon">
                                    <use xlink:href="assets/icons/icons-sprite.svg#close"></use>
                                </svg>
                            </button>
                        </div>
                    }
                </div>
            } @else {
                <div class="select-assets__playlist-empty">
                    <p>Upload a Content or Select/Add a Content</p>
                </div>
            }
        </div>
    </div>
</div>

@if (showUploader()) {
    <app-uploader [(showUploader)]="showUploader" />
}

<!-- Add content selection modal -->
@if (showAddContentsModal()) {
    <ntv-modal
        [isVisible]="showAddContentsModal()"
        size="xlarge"
        [showFooter]="true"
        modalHeight="85vh"
        (modalClose)="onCloseAddContentsModal()">
        <div modal-body class="select-assets__modal-body">
            <app-select-assets-modal
                #assetSelectionModal
                [showTabs]="false"
                selectedContentType="single"
                [dealerId]="draftDealerId()"
                (addContents)="getEmittedContents($event)" />
        </div>

        <div modal-footer class="select-assets__modal-footer">
            <ntv-button size="xl" (buttonClick)="onCloseAddContentsModal()">Cancel</ntv-button>
            <ntv-button size="xl" variant="accent" (buttonClick)="onConfirmAddContents()"
                >Add Content</ntv-button
            >
        </div>
    </ntv-modal>
}
